import React__default, { useState, useEffect } from 'react';
import { PROGRESS_STEP } from '../../constants.js';
import ProcessingZoneComponent from './ProcessingZoneComponent.js';

const ProcessingZoneContainer = ({ files, title, cancelBtnLabel = 'Cancel', onCancel, onProcess }) => {
    const [progressConfig, setProgressConfig] = useState({
        intervalId: 0,
        progress: PROGRESS_STEP
    });
    const areFilesUploading = !!files.find((file) => file.isUploading);
    useEffect(() => {
        // start processing files if no file is currently uploading
        if (files.length && !areFilesUploading && onProcess) {
            onProcess();
        }
    }, [areFilesUploading, files.length, onProcess]);
    let totalFileSize = 0;
    files.forEach((file) => (totalFileSize = totalFileSize + file.size));
    return (React__default.createElement(ProcessingZoneComponent, { title: title, cancelBtnLabel: cancelBtnLabel, areFilesUploading: areFilesUploading, totalFileSize: totalFileSize, progressConfig: progressConfig, setProgressConfig: setProgressConfig, onCancel: onCancel }));
};

export { ProcessingZoneContainer as default };
//# sourceMappingURL=ProcessingZoneContainer.js.map
